'use client';

import Turnstile from './index';
import { UseTurnstileReturn } from './useTurnstile';

type CaptchaFieldProps = {
  turnstile: UseTurnstileReturn;
  className?: string;
};

// Renders nothing when NEXT_PUBLIC_ENABLE_TURNSTILE is off, so forms using this
// component don't need their own enabled/disabled branching.
const CaptchaField = ({ turnstile, className }: CaptchaFieldProps) => {
  if (!turnstile.enabled) {
    return null;
  }

  return (
    <div className={className}>
      <Turnstile
        ref={turnstile.ref}
        siteKey={turnstile.siteKey}
        onVerify={turnstile.handleVerify}
        onExpire={turnstile.handleExpireOrError}
        onError={turnstile.handleExpireOrError}
      />
      {turnstile.error && <p className="mt-1 text-sm text-red-600">{turnstile.error}</p>}
    </div>
  );
};

export default CaptchaField;
